// ViewModel transforms raw API data into clean, display-ready properties with formatting and fallback values for the UI
import dateTime from '../../../utils/dateTime';

export class PrescriptionListItemViewModel {
  /**
   * See IPrescriptionForAdmin in ooca-webview-extensions project
   * @param {IPrescriptionForAdmin} prescription
   */
  constructor(prescription) {
    this.value = prescription;
  }

  get orderNumber() {
    return this.value.orderNumber;
  }

  get trackingNumber() {
    return this.value.trackingOrder ? this.value.trackingOrder.trackingNumber : null;
  }

  get deliveryType() {
    return this.value.deliveryType || '-';
  }

  get deliveryFee() {
    return (this.value.deliveryFee || 0).toFixed(2) + ' THB';
  }

  get medicineTotalFee() {
    if (this.value.transactions.length > 0) {
      if (this.value.transactions.length === 1) {
        if (this.value.transactions[0].discount) {
          return this.value.transactions[0].finalPrice + ' THB';
        }
        return this.value.transactions[0].amount + ' THB';
      }

      if (this.value.transactions.filter.discount) {
        const totalFee = this.value.transactions.reduce(
          (addingTransactionAmount, transactionAmount) => addingTransactionAmount + transactionAmount.finalPrice,
          0
        );
        return totalFee + ' THB';
      }

      const transactionsFilter = this.value.transactions.filter(
        (transaction) => transaction.resultCode === '00' && transaction.retryFlag === 'N'
      );

      if (transactionsFilter.length > 0) {
        const totalFee = transactionsFilter[0].amount;
        if (totalFee > 0) return totalFee + ' THB';
        else return '-';
      } else return '-';
    }
    return '-';
  }

  get medicines() {
    return this.value.detail ? this.value.detail.medicines : [];
  }

  get submittedAt() {
    return this.value.submittedAt ? dateTime.formatFromISO8601(this.value.submittedAt, 'YYYY-MM-DD HH:mm:ss') : '-';
  }

  get appointmentId() {
    return this.value.appointmentId;
  }

  get userId() {
    return this.value.patientId;
  }

  get providerStatus() {
    const history = this.value.history.find((record) => record.status === this.value.status);

    return {
      status: this.value.status,
      reason: history ? history.reason : undefined,
    };
  }

  get providerStatusUpdatedAt() {
    return this.value.providerStatusUpdatedAt
      ? dateTime.formatFromISO8601(this.value.providerStatusUpdatedAt, 'YYYY-MM-DD HH:mm:ss')
      : '-';
  }

  get patientStatus() {
    return this.value.statusPatient || '-';
  }

  get patientStatusUpdatedAt() {
    return this.value.patientStatusUpdatedAt
      ? dateTime.formatFromISO8601(this.value.patientStatusUpdatedAt, 'YYYY-MM-DD HH:mm:ss')
      : '-';
  }

  get comment() {
    return this.value.comment;
  }
  get patientPaidAt() {
    const transactions = this.value.transactions;
    return transactions.length > 0
      ? dateTime.formateDateTimeForDisplay(transactions[transactions.length - 1].lastUpdate, 'DD/MM/YYYY HH:mm')
      : '-';
  }

  get prescriptionId() {
    return this.value._id;
  }
}
